import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import React from "react";

import { connect } from "react-redux";

const ConfirmationDialog = (props) => {
  const {
    message,
    setConfirmationDialog,
    loading,
    confirmationDialog,
    onYes,
    noPreFormat,
    error,
    btnMessage,
    isLoading,
    disabled,
    onWait,
    size,
    title,
    color,
    alignContent,
    canRemoveDialogAction,
    dividers,
    onDecline,
    fullWidth = false,
  } = props;

  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={size || "xs"}
      onClose={() => {
        setConfirmationDialog(false);
      }}
      open={confirmationDialog}
    >
      <DialogTitle className={`text-primary`}>
        <span className="d-flex align-items-center">
          <span className="material-icons mr-1">check_circle</span>
          {title || "Confirm"}
        </span>
        <IconButton
          aria-label="close"
          onClick={() => {
            setConfirmationDialog(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className={`pb-0 text-${alignContent || "center"} ${
          error ? "text-danger" : ""
        } `}
        style={{ maxHeight: "700px" }}
      >
        {/* {loading || isLoading ? <LinearProgress />:''} */}

        {noPreFormat ? (
          message
        ) : (
          <pre
            style={{
              fontFamily: `"Roboto","Helvetica","Arial","sans-serif"`,
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "1.5",
              whiteSpace: "pre-wrap",
            }}
          >
            {message}
          </pre>
        )}
      </DialogContent>
      {!canRemoveDialogAction && (
        <DialogActions className="d-flex justify-content-center py-4">
          <Button
            disabled={loading || isLoading || disabled || onWait}
            color={color || "primary"}
            variant="contained"
            onClick={onYes}
            className="ml-2 px-4"
            loading={isLoading}
          >
            {loading || onWait ? "Wait..." : btnMessage || "Confirm"}
          </Button>
          {onDecline && (
            <Button
              disabled={loading || isLoading || disabled || onWait}
              color={"error"}
              variant="contained"
              onClick={onDecline}
              className="ml-2 px-4"
              loading={isLoading}
            >
              {loading || onWait ? "Wait..." : "Decline"}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

const mapStateToProps = ({ loading, onWait }) => {
  return { loading, onWait };
};
export default connect(mapStateToProps)(ConfirmationDialog);
